(() => {
  const body = document.body;
  const menu = document.querySelector('[data-mobile-menu]');
  const menuButtons = document.querySelectorAll('[data-menu-toggle]');
  const scrim = document.querySelector('[data-menu-scrim]');

  const setMenu = (open) => {
    body.classList.toggle('menu-open', open);
    menuButtons.forEach((button) => button.setAttribute('aria-expanded', String(open)));
    if (menu) menu.setAttribute('aria-hidden', String(!open));
  };

  menuButtons.forEach((button) => button.addEventListener('click', () => setMenu(!body.classList.contains('menu-open'))));
  if (scrim) scrim.addEventListener('click', () => setMenu(false));

  const searchPanel = document.querySelector('[data-search-panel]');
  const searchButtons = document.querySelectorAll('[data-search-toggle]');
  const setSearch = (open) => {
    body.classList.toggle('search-open', open);
    searchButtons.forEach((button) => button.setAttribute('aria-expanded', String(open)));
    if (searchPanel) searchPanel.setAttribute('aria-hidden', String(!open));
    if (open) window.setTimeout(() => searchPanel.querySelector('input')?.focus(), 250);
  };
  searchButtons.forEach((button) => button.addEventListener('click', () => setSearch(!body.classList.contains('search-open'))));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setMenu(false);
      setSearch(false);
    }
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-quantity-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const step = Number(input.step || 1);
      const min = Number(input.min || 1);
      input.value = Math.max(min, Number(input.value) + (button.dataset.quantityButton === 'plus' ? step : -step));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    root.classList.add('product-is-ready');
    const gallery = root.querySelector('[data-product-gallery]');
    const galleryItems = [...root.querySelectorAll('[data-media-index]')];
    const galleryDots = [...root.querySelectorAll('[data-gallery-dot], [data-gallery-thumb]')];
    let galleryFrame;

    const setActiveMedia = (index) => {
      galleryDots.forEach((dot) => {
        const active = Number(dot.dataset.galleryDot ?? dot.dataset.galleryThumb) === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    galleryDots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const item = galleryItems[Number(dot.dataset.galleryDot ?? dot.dataset.galleryThumb)];
        if (gallery && item) gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      });
    });

    if (gallery && galleryItems.length > 1) {
      gallery.addEventListener('scroll', () => {
        window.cancelAnimationFrame(galleryFrame);
        galleryFrame = window.requestAnimationFrame(() => {
          const currentIndex = galleryItems.reduce((closest, item, index) => {
            const distance = Math.abs(item.offsetLeft - gallery.scrollLeft);
            return distance < closest.distance ? { index, distance } : closest;
          }, { index: 0, distance: Infinity }).index;
          setActiveMedia(currentIndex);
        });
      }, { passive: true });
    }

    const form = root.querySelector('[data-product-form]');
    const variantSelect = root.querySelector('[data-variant-select]');
    const optionInputs = [...root.querySelectorAll('.product-option__input')];
    const primaryAdd = root.querySelector('[data-primary-add]');
    const stickyAdd = root.querySelector('[data-sticky-add]');
    const priceWrapper = root.querySelector('[data-product-price] .price');
    const priceCurrent = root.querySelector('[data-product-price] .price__current');
    let priceCompare = root.querySelector('[data-product-price] .price__compare');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyVariant = root.querySelector('[data-sticky-variant]');

    const updateButtons = (available) => {
      [primaryAdd, stickyAdd].forEach((button) => {
        if (!button) return;
        button.disabled = !available;
      });
      const label = available ? 'Add to cart' : 'Sold out';
      const expressCheckout = root.querySelector('.shopify-payment-button');
      if (expressCheckout) expressCheckout.hidden = !available;
      const primaryLabel = root.querySelector('[data-add-label]');
      const stickyLabel = root.querySelector('[data-sticky-add-label]');
      if (primaryLabel) primaryLabel.textContent = label;
      if (stickyLabel) stickyLabel.textContent = label;
    };

    const updateVariant = () => {
      if (!variantSelect || variantSelect.tagName !== 'SELECT') return;
      const selectedValues = [...root.querySelectorAll('[data-option-position]')].map((fieldset) => {
        return fieldset.querySelector('input:checked')?.value;
      });
      root.querySelectorAll('[data-selected-option]').forEach((label) => {
        label.textContent = selectedValues[Number(label.dataset.selectedOption)] || '';
      });

      const matchingOption = [...variantSelect.options].find((option) => {
        try {
          const values = JSON.parse(option.dataset.options || '[]');
          return values.length === selectedValues.length && values.every((value, index) => value === selectedValues[index]);
        } catch (error) {
          return false;
        }
      });

      if (!matchingOption) {
        variantSelect.value = '';
        updateButtons(false);
        const primaryLabel = root.querySelector('[data-add-label]');
        if (primaryLabel) primaryLabel.textContent = 'Unavailable combination';
        return;
      }

      variantSelect.value = matchingOption.value;
      const available = matchingOption.dataset.available === 'true';
      const price = matchingOption.dataset.price || '';
      const compare = matchingOption.dataset.compare || '';
      const title = matchingOption.dataset.title || '';

      if (priceCurrent) priceCurrent.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyVariant) stickyVariant.textContent = title;
      if (compare && !priceCompare && priceWrapper) {
        priceCompare = document.createElement('s');
        priceCompare.className = 'price__compare';
        priceWrapper.append(priceCompare);
      }
      if (priceCompare) {
        priceCompare.textContent = compare;
        priceCompare.hidden = !compare;
      }
      priceWrapper?.classList.toggle('price--sale', Boolean(compare));
      updateButtons(available);

      const mediaId = matchingOption.dataset.mediaId;
      if (gallery && mediaId) {
        const mediaItem = root.querySelector(`[data-media-id="${mediaId}"]`);
        if (mediaItem) {
          gallery.scrollTo({ left: mediaItem.offsetLeft, behavior: 'smooth' });
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', matchingOption.value);
      window.history.replaceState({}, '', url.toString());
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
    const initialOption = variantSelect?.selectedOptions?.[0];
    if (initialOption?.dataset.mediaId && gallery) {
      const initialMedia = root.querySelector(`[data-media-id="${initialOption.dataset.mediaId}"]`);
      if (initialMedia) {
        gallery.scrollTo({ left: initialMedia.offsetLeft, behavior: 'instant' });
        setActiveMedia(Number(initialMedia.dataset.mediaIndex));
      }
    }
    // Native forms remain the source of truth for cart submissions.
    form?.addEventListener('submit', (event) => {
      if (primaryAdd?.disabled || !variantSelect?.value) event.preventDefault();
    });
    if (stickyAdd && form && primaryAdd) {
      stickyAdd.addEventListener('click', () => form.requestSubmit(primaryAdd));
    }
  });

  document.querySelectorAll('[data-recommendations]').forEach((section) => {
    if (!section.dataset.url || section.dataset.loaded) return;
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      fetch(section.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const container = document.createElement('div');
          container.innerHTML = text;
          const rendered = container.querySelector('[data-recommendations]');
          if (rendered?.innerHTML.trim()) section.innerHTML = rendered.innerHTML;
          section.dataset.loaded = 'true';
        })
        .catch(() => {
          section.dataset.loaded = 'true';
        });
    }, { rootMargin: '0px 0px 300px 0px' });
    observer.observe(section);
  });
})();
